<template>
  <ContentModal :model-value="modelValue" title="Lead Generation & Outreach" size="2xl" @update:modelValue="onUpdateModelValue">
    <NavTabs>
      <NavTab target="contacts" v-model:activeTab="activeTab">Leads & Contacts</NavTab>
      <NavTab target="logs" v-model:activeTab="activeTab">SES Email Logs</NavTab>
      <NavTab target="locations" v-model:activeTab="activeTab">Target Locations</NavTab>
      <NavTab target="reports" v-model:activeTab="activeTab">Reports & Stats</NavTab>
    </NavTabs>

    <div class="mt-3">
      <LeadsContactsTab v-if="activeTab === 'contacts'" />
      <SesEmailLogsTab v-else-if="activeTab === 'logs'" />
      <TargetLocationsTab v-else-if="activeTab === 'locations'" />
      <LeadReportsTab v-else-if="activeTab === 'reports'" />
    </div>
  </ContentModal>
</template>

<script setup>
import { ref } from 'vue'
import ContentModal from '@/components/Modal/ContentModal.vue'
import NavTabs from '@/components/Tabs/NavTabs.vue'
import NavTab from '@/components/Tabs/NavTab.vue'
import LeadsContactsTab from './tabs/LeadsContactsTab.vue'
import SesEmailLogsTab from './tabs/SesEmailLogsTab.vue'
import TargetLocationsTab from './tabs/TargetLocationsTab.vue'
import LeadReportsTab from './tabs/LeadReportsTab.vue'

defineProps({
  modelValue: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue', 'closed'])

const activeTab = ref('contacts')

function onUpdateModelValue(value) {
  emit('update:modelValue', value)
  if (!value) {
    emit('closed')
  }
}
</script>
